import React from 'react';
import { Badge } from 'reactstrap';

function ResultJobStatusField({ value, data, showErrorDetails = false }) {
  if (!value) return <>-</>;

  if (showErrorDetails && value === 'COMPLETED' && data?.error?.message) {
    return (
      <div className="master-special">
        <Badge>Completato con avvisi</Badge>
        <small style={{ display: 'block' }}>{data.error.message}</small>
      </div>
    );
  }

  if (value === 'ERROR') {
    return (
      <div className="master-no">
        <Badge>In errore</Badge>
      </div>
    );
  } else if (value === 'IAF_INVOICES_SKIPPED_NON_POSITIVE') {
    return (
      <div className="master-special">
        <Badge>Completato con avvisi</Badge>
        {data?.error?.message && (
          <small style={{ display: 'block' }}>{data.error.message}</small>
        )}
      </div>
    );
  } else if (value === 'SKIPPED_NON_POSITIVE') {
    return (
      <div className="master-special">
        <Badge>Non creata: totale pari o inferiore a zero</Badge>
        {data?.error?.message && (
          <small style={{ display: 'block' }}>{data.error.message}</small>
        )}
      </div>
    );
  } else if (value === 'COMPLETED') {
    return (
      <div className="master-yes">
        <Badge>Completato</Badge>
      </div>
    );
  } else if (value === 'EMAIL_NOT_SENT') {
    return (
      <div className="master-no">
        <Badge>Email non inviata</Badge>
      </div>
    );
  } else {
    return <>-</>;
  }
}

export default ResultJobStatusField;
